import { err } from "@/mocks/handlers/domains/_utils";
import { handleAdmin } from "@/mocks/handlers/domains/admin";
import { handleAnalytics } from "@/mocks/handlers/domains/analytics";
import { handleContent } from "@/mocks/handlers/domains/content";
import { handleGames } from "@/mocks/handlers/domains/games";
import { handlePackages } from "@/mocks/handlers/domains/packages";
import { handleSdk } from "@/mocks/handlers/domains/sdk";
import { handleSession } from "@/mocks/handlers/domains/session";
import { handleShareConfigs } from "@/mocks/handlers/domains/share-configs";

export interface MockRequest {
  method: string;
  path: string;
  query: URLSearchParams;
  body?: unknown;
  headers?: Record<string, string>;
}

export interface MockResponse {
  status: number;
  body: unknown;
}

const domainHandlers = [
  handleSession,
  handleGames,
  handlePackages,
  handleContent,
  handleShareConfigs,
  handleAnalytics,
  handleSdk,
  handleAdmin,
];

/** Core mock HTTP router — used by MSW handlers (and Vitest in-process mode). */
export function handleMockRequest(req: MockRequest): MockResponse {
  const method = req.method.toUpperCase();
  const path = req.path.replace(/\/+$/, "") || "/";

  for (const handler of domainHandlers) {
    const response = handler({ ...req, method, path });
    if (response) return response;
  }

  return err(404, "NOT_FOUND", `未实现的接口 ${method} ${path}`);
}
